import { COLORS, BG_BASE, COLOR_GOOD, COLOR_WARN, COLOR_POOR } from "../../utils/colors";

function getScoreColor(score) {
  if (score >= 7.0) return COLOR_GOOD;
  if (score >= 5.0) return COLOR_WARN;
  return COLOR_POOR;
}

const sampleData = {
  totalScore: 9.0,
  components: [
    { name: "Collaboration Network",      score: 10.0, weight: 0.5,  color: COLORS.green  },
    { name: "DISC Engagement Fit",        score: 8.7,  weight: 0.25, color: COLORS.purple },
    { name: "StrengthsFinder Alignment",  score: 7.4,  weight: 0.25, color: COLORS.teal   },
  ],
};

export default function ChemistryCompositeScore({ data }) {
  const d = data || sampleData;
  const totalColor = getScoreColor(d.totalScore);

  return (
    <div style={{
      background: COLORS.cardBg, border: `1px solid ${COLORS.cardBorder}`,
      borderRadius: 8, padding: 20, marginBottom: 16,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, color: COLORS.text, margin: 0, textTransform: "uppercase", letterSpacing: 1 }}>
          Team Chemistry Score
        </h3>
        <div style={{
          width: 64, height: 64, borderRadius: "50%",
          border: `4px solid ${totalColor}`,
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          background: `${totalColor}10`,
        }}>
          <span style={{ fontSize: 24, fontWeight: 800, color: totalColor, lineHeight: 1 }}>{d.totalScore.toFixed(1)}</span>
        </div>
      </div>

      <div style={{ fontSize: 11, color: COLORS.textMuted, lineHeight: 1.6, marginTop: 4 }}>
        Weighted composite: Collaboration Network (50%) + DISC Engagement Fit (25%) + StrengthsFinder Alignment (25%).
        Detailed breakdowns for each dimension are in the sections below.
      </div>
    </div>
  );
}
